import globalUtils from '../../../utils/global.util';
import stringUtils from '../../../utils/string.utils';

const { isNullOrEmpty } = stringUtils;
const validate = (values) => {
    const errors = {};
    const {
        customerName,
        email,
        phoneNumber,
        addressName,
        address,
        cityId,
        districtId,
        wardId,
    } = values;

    if (isNullOrEmpty(customerName)) {
        errors.customerName = 'Họ tên không được để trống';
    }
    if (isNullOrEmpty(email)) {
        errors.email = 'Địa chỉ email không được để trống';
    } else {
        if (!globalUtils.validateEmail(email)) {
            errors.email = 'Địa chỉ email không đúng định dạng';
        }
    }
    if (isNullOrEmpty(phoneNumber)) {
        errors.phoneNumber = 'Số điện thoại không được để trống';
    }

    if (isNullOrEmpty(addressName)) {
        errors.addressName = 'Tên địa chỉ giao hàng không được để trống';
    }

    if (isNullOrEmpty(address)) {
        errors.address = 'Địa chỉ không để trống';
    }

    if (isNullOrEmpty(cityId)) {
        errors.cityId = 'Tỉnh/Thành phố không được để trống';
    }

    if (isNullOrEmpty(districtId)) {
        errors.districtId = 'Quận/Huyện không được để trống';
    }

    if (isNullOrEmpty(wardId)) {
        errors.wardId = 'Phường/Xã không được để trống';
    }

    return errors;
};
export default validate;
